module.exports = __webpack_public_path__ + "img/swiper1.b4f0aca5.jpg";